const SvgModernize3 = (props) => (
  <>
    <path
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
      d="M96 0v92M96 288v96M96 196v92M96 188v-88M96 0l96 96h-92M96 0 0 96h92M100 192h92L98.83 98.83M93.17 98.83 0 192h92M98.83 194.83 192 288H96M93.17 194.83 0 288h96"
    />
    <path
      d="M92 96c0-2.21 1.79-4 4-4M93.17 98.83A3.99 3.99 0 0 1 92 96M93.17 98.83A3.99 3.99 0 0 0 96 100M96 100c1.1 0 2.1-.45 2.83-1.17M100 96c0 1.1-.45 2.1-1.17 2.83M100 96c0-2.21-1.79-4-4-4M93.17 194.83A3.99 3.99 0 0 0 96 196M98.83 194.83A3.99 3.99 0 0 1 96 196M100 192c0-2.21-1.79-4-4-4M92 192c0 1.1.45 2.1 1.17 2.83M92 192c0-2.21 1.79-4 4-4M98.83 194.83A3.99 3.99 0 0 0 100 192"
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
    />
  </>
);

export default SvgModernize3;
